/**
 * Created by Rodrigo Quesada on 27/12/16.
 */
import {Observable} from 'rxjs';

export function publishReplayLastThenConnect<T>(observable: Observable<T>): Observable<T> {
    let publishedVersion = observable.publishReplay(1);
    publishedVersion.connect();
    return publishedVersion;
}

export function afterAnotherCompletes<R>(observable: Observable<R>, another: Observable<any>): Observable<R> {
    return another.switchMap(value => observable);
}

export function fromFunction<R>(call: () => R): Observable<R> {
    return Observable.create((subscriber) => {
        subscriber.next(call());
        subscriber.complete();
    });
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/rx/observables.util.ts